import React from 'react';

function EmailTemplateGuide() {
    return (
        <div>
            <h2 style={{ fontSize: "24px", fontWeight: "300", color: "#000000", marginBottom: "10px" }}>
                Streamlining Your Workflow with Email Template
            </h2>
            <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F", marginBottom: "20px" }}>
                Managing email templates efficiently can save you time and enhance communication. Here’s how to create, edit, and delete email templates:
            </p>
            <img 
                    src="https://45323494.fs1.hubspotusercontent-na1.net/hubfs/45323494/Screenshot%202024-12-26%20180712-png.png" // Replace with your image URL
                    alt="Create Approval Manager"
                    style={{ width: "60%", height: "auto", marginBottom: "20px" }}
                />
            <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Creating a New Email Template
            </h3>
            <ol style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
                <li>Go to the <strong>"Emails"</strong> section in your account.</li>
                <li>Click on <strong>"Add Email Template"</strong> to create a new template.</li>
                <li>Fill in the required details, including any custom fields you need for personalization.</li>
                <li>Once all the information is in place, click <strong>"Save"</strong> to store your template.</li>
            </ol>

            <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Editing an Existing Email Template
            </h3>
            <img 
                    src="https://via.placeholder.com/800x400" // Replace with your image URL
                    alt="Create Approval Manager"
                    style={{ width: "60%", height: "auto", marginBottom: "20px" }}
                />
            <ol style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
                <li>To make changes to an existing template, locate the email you want to edit.</li>
                <li>Click on the <strong>"Edit"</strong> button next to the template.</li>
                <li>After making the necessary adjustments, click <strong>"Save"</strong> to update your template.</li>
            </ol>

            <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Deleting an Email Template
            </h3>
            <ol style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
                <li>Find the template you wish to remove.</li>
                <li>Click <strong>"Delete"</strong> and confirm the action to permanently delete the template.</li>
            </ol>
            <img 
                    src="https://via.placeholder.com/800x400" // Replace with your image URL
                    alt="Create Approval Manager"
                    style={{ width: "60%", height: "auto", marginBottom: "20px" }}
                />
            <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Things to Remember
            </h3>
            <ul style={{ fontSize: "16px", lineHeight: "1.6", color: "#4F4F4F" }}>
                <li>Templates help streamline your email communication and save time.</li>
                <li>Be cautious when deleting templates, as this action is irreversible.</li>
                <li>For further assistance, refer to the user manual or contact support.</li>
            </ul>
        </div>
    );
}

export default EmailTemplateGuide;
